export enum ListingType {
  Buying,
  Selling,
}
